import {getThumbnailLink} from "../../utils/get_thumbnail_link";

export const getPropertyPlanImages = (
    propertyPlanPages: {
        image_url?: string | null;
    }[]
) => {
    return propertyPlanPages.map(({image_url}) => ({
        srcSm: getThumbnailLink(image_url, 560),
        srcMd: getThumbnailLink(image_url, 980),
        srcLg: getThumbnailLink(image_url, 1500)
    }));
};
import {getThumbnailLink} from "../../utils/get_thumbnail_link";

export const getPropertyPlanImages = (
    propertyPlanPages: {
        image_url?: string | null;
    }[]
) => {
    return propertyPlanPages.map(({image_url}) => ({
        srcSm: getThumbnailLink(image_url, 560),
        srcMd: getThumbnailLink(image_url, 980),
        srcLg: getThumbnailLink(image_url, 1500)
    }));
};
